import React, { FC, ReactNode } from 'react';
import styles from './CategoryContainer.module.scss';

export interface CategoryContainerProps {
  children: ReactNode;
  className?: string;
}

export const CategoryContainer: FC<CategoryContainerProps> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
